import { Directive, HostListener, ElementRef, Renderer2, Input, AfterContentInit } from "@angular/core";

@Directive({
    selector: "[scrollListItem]"
})
export class ScrollListItemDirective implements AfterContentInit {

    @Input() highlightClassName: string;
    @Input() scrollDisabled: boolean;
    @Input() blockedPositionWithElementHeight: boolean;
    @Input() decreaseOpacity: boolean;

    private timer: ReturnType<typeof setTimeout>;
    private startY: number;
    private nextSelectedElement: number;
    private listHTMLElement: HTMLUListElement;

    constructor(
        private _el: ElementRef,
        private _renderer: Renderer2) { }

    ngAfterContentInit() {
        this.listHTMLElement = this._el.nativeElement.querySelector("ul");
        if (this.decreaseOpacity) {
            this.setOpacityLevel(0);
        }
    }

    @HostListener("touchstart", ["$event"]) touchStart(event: TouchEvent) {
        this.startY = event.touches.item(0).clientY;
    }

    @HostListener("touchmove", ["$event"]) checkOffsetTopq(event: TouchEvent) {
        const gap = window.outerHeight / 16;
        const touchY = parseInt(event.touches.item(0).clientY.toString(), 10);
        if ((this.scrollDisabled === null || !this.scrollDisabled)
            && this.startY) {
            if (Math.abs(touchY - this.startY) > gap) {
                this.selectNextElement(touchY > this.startY);
                this.startY = touchY;
            }
        }
    }

    private selectNextElement(up: boolean) {
        this.nextSelectedElement = null;
        const childrens = Array.from(this.listHTMLElement.children);
        childrens.forEach((child: HTMLElement, index) => {
            if (this.nextSelectedElement === null && child.className.indexOf(this.highlightClassName) !== -1) {
                if ((up && index === 0) || (!up && (index + 1) === childrens.length)) {
                    return;
                }

                this.deselectElement(index);
                this.nextSelectedElement = up ? (index - 1) : (index + 1);
                this.selectElement(this.nextSelectedElement);

                if (this.decreaseOpacity) {
                    this.setOpacityLevel(this.nextSelectedElement);
                }
            }
        });
    }

    private selectElement(selectedIndex: number) {
        const childrens = this.listHTMLElement.children;
        if (this.blockedPositionWithElementHeight) {
            this._renderer.setStyle(
                childrens[0], "margin-top", (-1 * childrens[selectedIndex].clientHeight * 2 * selectedIndex).toString() + "px");
        }
        this._renderer.addClass(childrens[selectedIndex], this.highlightClassName);
        this._renderer.setAttribute(childrens[selectedIndex], "active-element", "true");
    }

    private deselectElement(selectedIndex: number) {
        const childrens = this.listHTMLElement.children;
        this._renderer.removeClass(childrens[selectedIndex], this.highlightClassName);
        this._renderer.removeAttribute(childrens[selectedIndex], "active-element");
    }

    private setOpacityLevel(selectedIndex: number) {
        const childrens = Array.from(this.listHTMLElement.children);
        childrens.forEach((child: HTMLElement, index) => {
            const abs = Math.abs(selectedIndex - index);
            switch (abs) {
                case 0:
                    child.style.opacity = "1";
                    break;
                case 1:
                    child.style.opacity = "0.75";
                    break;
                default:
                    child.style.opacity = "0.5";
                    break;
            }
        });
    }
}
